// extracted by mini-css-extract-plugin
module.exports = {"bgColor":"submenuV2_bgColor__MUCyy","iconColor":"submenuV2_iconColor__jJdIb","textLink":"submenuV2_textLink__GftIG"};